import { useSetAtom } from 'jotai'
import { useRef } from 'react'
import { highlightedFieldPathsAtom } from '../atoms'

const HOVER_SCROLL_DELAY_MS = 500
export const HighlightFieldPathsOnHover = ({
  children,
  fieldPaths
}: {
  children: React.ReactNode
  fieldPaths: string[]
}) => {
  const setHighlightedFieldPaths = useSetAtom(highlightedFieldPathsAtom)
  const hoverTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  return (
    <div
      style={{ width: '100%' }}
      onMouseOver={e => {
        e.stopPropagation()

        // Clear any existing timeout
        if (hoverTimeoutRef.current) {
          clearTimeout(hoverTimeoutRef.current)
        }

        // Set highlighted field paths after 500ms delay
        hoverTimeoutRef.current = setTimeout(() => {
          setHighlightedFieldPaths(fieldPaths)
        }, HOVER_SCROLL_DELAY_MS)
      }}
      onMouseOut={e => {
        e.stopPropagation()

        // Clear timeout if mouse leaves before delay completes
        if (hoverTimeoutRef.current) {
          clearTimeout(hoverTimeoutRef.current)
          hoverTimeoutRef.current = null
        }

        setHighlightedFieldPaths(undefined)
      }}
    >
      {children}
    </div>
  )
}
